// data.ts

export const prefixes = [
  { country: 'USA/CAD', prefix: '+1', flag: '🇺🇸/🇨🇦' },
  { country: 'UK', prefix: '+44', flag: '🇬🇧' },
  { country: 'Australia', prefix: '+61', flag: '🇦🇺' },
  { country: 'India', prefix: '+91', flag: '🇮🇳' },
  { country: 'Germany', prefix: '+49', flag: '🇩🇪' },
  { country: 'France', prefix: '+33', flag: '🇫🇷' },
  { country: 'China', prefix: '+86', flag: '🇨🇳' },
  { country: 'Japan', prefix: '+81', flag: '🇯🇵' },
  { country: 'Brazil', prefix: '+55', flag: '🇧🇷' },
  { country: 'Mexico', prefix: '+52', flag: '🇲🇽' },
  { country: 'South Africa', prefix: '+27', flag: '🇿🇦' },
  { country: 'Albania', prefix: '+355', flag: '🇦🇱' },
];

export const degreeOptions = [
  { id: 'High School Diploma', name: 'High School Diploma' },
  { id: 'Associate Degree', name: 'Associate Degree' },
  { id: 'Bachelor Degree', name: 'Bachelor Degree' },
  { id: 'Master Degree', name: 'Master Degree' },
  { id: 'Doctorate', name: 'Doctorate' },
];

export const ethnicities = [
  { id: 'Caucasian', name: 'Caucasian' },
  { id: 'Hispanic', name: 'Hispanic' },
  { id: 'African American', name: 'African American' },
  { id: 'Asian', name: 'Asian' },
  { id: 'Native American', name: 'Native American' },
  { id: 'Pacific Islander', name: 'Pacific Islander' },
  { id: 'Mixed Race', name: 'Mixed Race' },
  { id: 'Other', name: 'Other' },
];

export const bestTimeToCallOptions = [
  { id: 'Morning', name: 'Morning' },
  { id: 'Midday', name: 'Midday' },
  { id: 'Evenings', name: 'Evenings' },
];

export const maritalStatuses = [
  { id: 'Single', name: 'Single' },
  { id: 'Married', name: 'Married' },
  { id: 'Divorced', name: 'Divorced' },
  { id: 'Widowed', name: 'Widowed' },
];

export const genders = [
  { id: 'Male', name: 'Male' },
  { id: 'Female', name: 'Female' },
  { id: 'Non-Binary', name: 'Non-Binary' },
  { id: 'No Information', name: 'No Information' },
];

export const contactMethods = [
  { id: 'Sms', name: 'Sms' },
  { id: 'Email', name: 'Email' },
  { id: 'Phone', name: 'Phone' },
];

export const NotificationType = [
  { id: 'New lead', name: 'New lead' },
  { id: 'Activity', name: 'Activity' },
  { id: 'Error message', name: 'Error message' },
  { id: 'Upload documents', name: 'Upload documents' },
  { id: 'Message', name: 'Message' },
  { id: 'Assignment', name: 'Assignment' },
  { id: 'Reminder', name: 'Reminder' },
  { id: 'Overdue', name: 'Overdue' },
  { id: 'Other', name: 'Other' },
];

export enum NotificationTypeEnum {
  NewLead = 'New lead',
  Activity = 'Activity',
  ErrorMessage = 'Error message',
  UploadDocuments = 'Upload documents',
  Message = 'Message',
  Assignment = 'Assignment',
  Reminder = 'Reminder',
  Overdue = 'Overdue',
  Other = 'Other',
  IMPORT_SUCCSESS = 'Import',
  IMPORT_FAILED = 'Import failed',
  GROUP_MESSAGE_FAILED = 'Group message failed',
  GROUP_MESSAGE_SOME_FAILED = 'Group message some failed',
  GROUP_MESSAGE_SUCCESSFULLY = 'Group message Successfully',
  SEPERATE_LEAD_RESOLVE = 'Seperate lead resolve'
}

export enum DocumentSatus {
  SMS = 'Sms',
  EMAIL = 'Email',
  NOTE = 'Note',
  REASSIGN = 'Reassign'
}



export enum DocumentStatus {
  DRAFT = 'DRAFT',
  NOT_SUBMITTED = 'NOT_SUBMITTED',
  SUBMITTED = 'SUBMITTED',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED'
}